/*
 * @Author: tianzhi 
 * @Date: 2019-09-03 17:58:27 
 * @Last Modified by: tianzhi
 * @Last Modified time: 2019-09-06 10:46:13
 */
import React from 'react';
import { Icon } from 'antd';
import './style.less';
export default class SpinLoading extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Icon data-inspector-line="19" data-inspector-column="6" data-inspector-relative-path="src\\components\\SpinLoading\\index.jsx" type="loading" className="custom-loading" spin />;
  }

}